import { render, staticRenderFns } from "./healthy.vue?vue&type=template&id=361bc226&scoped=true&"
import script from "./healthy.vue?vue&type=script&lang=js&"
export * from "./healthy.vue?vue&type=script&lang=js&"
import style0 from "./healthy.vue?vue&type=style&index=0&id=361bc226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361bc226",
  null
  
)

export default component.exports